import { Radio } from 'antd'
import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useIntl } from '@/i18n/hooks/use-intl'

const { Group, Button } = Radio

export type Granularity = 'day' | 'week' | 'month'

interface GranularityProps {
  value?: Granularity
  onChange: (string) => void
  className?: string
  disabled?: boolean
}

const TimeGranularitySelector: FunctionComponent<GranularityProps> = ({
  value,
  onChange,
  className,
  disabled,
}) => {
  const { formatMessage } = useIntl()
  return (
    <Group
      className={className}
      disabled={disabled}
      value={value}
      onChange={(e): void => onChange(e.target.value)}
    >
      {[
        { key: 'day', text: formatMessage({ id: 'kol:option_daily' }) },
        { key: 'week', text: formatMessage({ id: 'kol:post_option_weekly' }) },
        {
          key: 'month',
          text: formatMessage({ id: 'kol:post_option_monthly' }),
        },
      ].map(({ key, text }) => (
        <Button key={key} value={key}>
          {text}
        </Button>
      ))}
    </Group>
  )
}

export default styled(TimeGranularitySelector)``
